module.exports = __webpack_public_path__ + "img/jrbg.daa7475a.jpg";